<template><div><h1 id="partienliste-nach-typ" tabindex="-1"><a class="header-anchor" href="#partienliste-nach-typ"><span>Partienliste nach Typ</span></a></h1>
<p>Partienliste nach Typ — Partienliste nach Typ</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Übersichtsliste der Partien eines bestimmten Partientyps (nur NICHT assemblierte Artikel). Einschränkung auf Artikel eines bestimmten Produktmanagers oder nur Artikel mit Restmenge möglich. Sortierung nach Artikelnummer, innerhalb Artikel nach Partiennummer.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Partienliste nach Typ</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Produkt Manager</dt>
<dd>Produkt Manager, leer = alle</dd>
<dt>Partientyp</dt>
<dd>Partientyp, nur 1 Partientyp möglich, Muss-Eingabe</dd>
<dt>mit Restmenge</dt>
<dd>R = mit Restmenge &gt; 0, leer = alle (auch Null-Partien)</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikelbezeichnung</td>
<td></td>
</tr>
<tr>
<td>Epreis/Einh.</td>
<td>Einkaufspreis pro Stk. aus Artikelstamm</td>
</tr>
<tr>
<td>VPreis</td>
<td>Verkaufspreis pro Stk. aus Artikelstamm</td>
</tr>
<tr>
<td>Spalten für Partien</td>
<td>Spalten für Partien</td>
</tr>
<tr>
<td>Pnr</td>
<td>Partiennummer</td>
</tr>
<tr>
<td>T</td>
<td>Partientyp Lieferung, Korrektur, Abschreibung, Verkaufbare Partie, Defekte Partie, Musterpartie, Nicht verkaufbare Partie, Inventurkorrektur</td>
</tr>
<tr>
<td>Datum</td>
<td>Erfassungsdatum der Partie</td>
</tr>
<tr>
<td>Erf</td>
<td>Erfasser der Partie = Mitarbeiterkürzel</td>
</tr>
<tr>
<td>BNr</td>
<td>Bestellungsnummer (nur bei Typ L)</td>
</tr>
<tr>
<td>UrMenge</td>
<td>Ursprüngliche Menge (z.B. Liefermenge, Inventurdifferenz)</td>
</tr>
<tr>
<td>RestMenge</td>
<td>Restmenge der Partie, d.h. effektive Menge der Partie</td>
</tr>
<tr>
<td>EKPreis</td>
<td>Einkaufspreis der Partie (in Bestandes-Partien nicht änderbar, d.h. in Partietypen V, D, N, M)</td>
</tr>
<tr>
<td>Zusatzkost</td>
<td>Zusatzkosten für die Partie (in Bestandes-Partien nicht änderbar)</td>
</tr>
<tr>
<td>VerfallD</td>
<td>Verfalldatum der Partie Partie gültig bis [Verfalldatum]</td>
</tr>
<tr>
<td>St</td>
<td>Status der Partie</td>
</tr>
<tr>
<td>Bemerkung</td>
<td>Bemerkungen zur Partie</td>
</tr>
<tr>
<td>LagerOrt</td>
<td>Lagernummer</td>
</tr>
<tr>
<td>LPlatz</td>
<td>Lagerplatz-Nummer</td>
</tr>
<tr>
<td>LgSt</td>
<td>Lagerstatus, I = intern, E = extern</td>
</tr>
<tr>
<td>Eig</td>
<td>Eigentums-Status 1=Internes Lager, 2=Lieferantenlager</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Partienliste nach Typ                20.08.1999 11:46:05 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">ArtNum  Artikelbezeichnung                  EPreis/Einh..   VPreis</span>
<span class="line">10101   Girarde, Schachtel                           3.50    18.00</span>
<span class="line"></span>
<span class="line">                                    Partien</span>
<span class="line"> Pnr T Datum      Erf BNr UrMenge RestMenge  EKPreis Zusatzkost VerfallD   St</span>
<span class="line">       Bemerkung                                      LagerOrt LPlatz LgSt Eig</span>
<span class="line">   1 V 09.01.1997 leh                     0     0.00       0.00</span>
<span class="line">                                                         1,350        I      1</span>
<span class="line">   2 V 02.01.1998 leh        100          2     0.00       0.00</span>
<span class="line">                                                         1,289               1</span>
<span class="line">   3 V 02.11.1997 leh                     0     0.00       0.00</span>
<span class="line">                                                         1,161        I      1</span>
<span class="line">--------------------------------------------------------------------------------</span>
<span class="line"></span>
<span class="line">ArtNum  Artikelbezeichnung                  EPreis/Einh..   VPreis</span>
<span class="line">2001G   Kniffke, Weihnachten                        13.50    18.50</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Vom Artikel 10101 gibt es noch 1 verkaufbare Partie mit Bestand, und zwar im Lager 1'289.</p>
</div></template>


